import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { AccountDeletionComponent } from './Components/account-deletion/account-deletion.component';
import { MobileUsersComponent } from './Components/Dashboard/mobile-users/mobile-users.component';
import { RedeemDashboardComponent } from './Components/Dashboard/redeem-dashboard/redeem-dashboard.component';
import { RegisteredUsersComponent } from './Components/Dashboard/registered-users/registered-users.component';
import { RequestDashboardComponent } from './Components/Dashboard/request-dashboard/request-dashboard.component';
import { VerificationDashboardComponent } from './Components/Dashboard/verification-dashboard/verification-dashboard.component';
import { LoginComponent } from './Components/login/login.component';
import { MapsComponent } from './Components/maps/maps.component';
import { CityConfigurationComponent } from './Components/Master Information/city-configuration/city-configuration.component';
import { CityComponent } from './Components/Master Information/city/city.component';
import { ZonesComponent } from './Components/Master Information/zones/zones.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { ViewTimelineComponent } from './Components/Request-management/view-timeline/view-timeline.component';
import { DumpsterComponent } from './Components/User Management/dumpster/dumpster.component';
import { DumpyardComponent } from './Components/User Management/dumpyard/dumpyard.component';
import { OnOffBusinessComponent } from './Components/User Management/on-off-business/on-off-business.component';
import { RequestorComponent } from './Components/User Management/requestor/requestor.component';
import { SuperUsersComponent } from './Components/Management-Console/super-users/super-users.component';
import { MenuConfigurationComponent } from './Components/Master Information/menu-configuration/menu-configuration.component';
import { RevenueDashboardComponent } from './Components/Dashboard/revenue-dashboard/revenue-dashboard.component';
import { SalesDashboardComponent } from './Components/Dashboard/sales-dashboard/sales-dashboard.component';
import { SalesGridDashboardComponent } from './Components/Reports/sales-grid-dashboard/sales-grid-dashboard.component';
import { DateOrderSummaryComponent } from './Components/Reports/date-order-summary/date-order-summary.component';
import { OrderSummaryComponent } from './Components/Reports/order-summary/order-summary.component';
import { RequestorSummaryReportComponent } from './Components/Reports/requestor-summary-report/requestor-summary-report.component';
import { UserMenuConfigComponent } from './Components/Master Information/user-menu-config/user-menu-config/user-menu-config.component';
import { SubscriptionRegistrationComponent } from './Components/Master Information/subscription-registration/subscription-registration.component';
import { BaldiaApprovalComponent } from './Components/Baldia/baldia-approval/baldia-approval.component';
import { TotalRequestComponent } from './Components/Request-management/total-request/total-request.component';
import { ProcessOrderComponent } from './Components/Order-management/process-order/process-order.component';
import { ProcessPaymentComponent } from './Components/Order-management/process-payment/process-payment.component';
import { ContainersComponent } from './Components/Master Information/containers/containers.component';
import { VersionStatusComponent } from './Components/Master Information/version-status/version-status.component';
import { SmsLogComponent } from './Components/Master Information/sms-log/sms-log.component';
import { NotificationsComponent } from './Components/Master Information/notifications/notifications.component';
import { PriceConfigurationComponent } from './Components/Master Information/price-configuration/price-configuration.component';
import { PercentageConfigureComponent } from './Components/Master Information/percentage-configure/percentage-configure.component';
import { BaldiaOrderHistoryComponent } from './Components/baldia-order-history/baldia-order-history.component';
import { LoaderComponent } from './Components/loader/loader.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { PushNotificationComponent } from './Components/push-notification/push-notification.component';
import { DumpyardLocationComponent } from './Components/maps/dumpyard-location/dumpyard-location.component';
import { BaldiaOverallDashboardComponent } from './Components/baldia-overall-dashboard/baldia-overall-dashboard.component';
import { StatusDashboardComponent } from './Components/status-dashboard/status-dashboard.component';
import { DumpsterLocationComponent } from './Components/maps/dumpster-location/dumpster-location.component';
import { LanguageComponent } from './Components/language/language.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  // Protected routes
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'request-dashboard', component: RequestDashboardComponent },
      { path: 'revenue-dashboard', component: RevenueDashboardComponent },
      { path: 'redeem-dashboard', component: RedeemDashboardComponent },
      { path: 'sales-dashboard', component: SalesDashboardComponent },
      { path: 'registered-users', component: RegisteredUsersComponent },
      { path: 'mobile-users', component: MobileUsersComponent },
      {
        path: 'verification-dashboard',
        component: VerificationDashboardComponent,
      },
      { path: 'total-request', component: TotalRequestComponent },
      { path: 'process-order', component: ProcessOrderComponent },
      { path: 'process-payment', component: ProcessPaymentComponent },
      { path: 'city', component: CityComponent },
      { path: 'zones', component: ZonesComponent },
      { path: 'containers', component: ContainersComponent },
      { path: 'requestor', component: RequestorComponent },
      { path: 'dumpster', component: DumpsterComponent },
      { path: 'dumpyard', component: DumpyardComponent },
      { path: 'version-status', component: VersionStatusComponent },
      { path: 'sms-log', component: SmsLogComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'orderSummary-reports', component: OrderSummaryComponent },
      { path: 'price-configuration', component: PriceConfigurationComponent },
      {
        path: 'user-summaryReport',
        component: RequestorSummaryReportComponent,
      },
      // { path: 'userVerification', component: UserVerificationComponent },
      { path: 'on-off-business', component: OnOffBusinessComponent },
      { path: 'salesGrid-dashboard', component: SalesGridDashboardComponent },
      { path: 'view-timeline/:id', component: ViewTimelineComponent },
      {
        path: 'verification-dashboard',
        component: VerificationDashboardComponent,
      },
      { path: 'maps', component: MapsComponent },
      { path: 'percentage-configure', component: PercentageConfigureComponent },
      { path: 'city-configuration', component: CityConfigurationComponent },
      { path: 'date-order-summary', component: DateOrderSummaryComponent },
      { path: 'super-users', component: SuperUsersComponent },
      { path: 'menu-configuration', component: MenuConfigurationComponent },
      { path: 'user-menu-config', component: UserMenuConfigComponent },
      { path: 'baldia-order-history', component: BaldiaOrderHistoryComponent },
      { path: 'account-deletion', component: AccountDeletionComponent },
      // { path: 'privacy-policy', component: PrivacyPolicyComponent },
      {
        path: 'subscription-registration',
        component: SubscriptionRegistrationComponent,
      },
      { path: 'dumpyard-location', component: DumpyardLocationComponent },
      { path: 'baldia-approval', component: BaldiaApprovalComponent },
      {
        path: 'baldia-overall-dashboard',
        component: BaldiaOverallDashboardComponent,
      },
      { path: 'dumpster-location', component: DumpsterLocationComponent },
      { path: 'status-dashboard', component: StatusDashboardComponent },
      { path: 'loader', component: LoaderComponent },
      { path: 'push-notification', component: PushNotificationComponent },
      { path: 'language', component: LanguageComponent },
    ],
  },

  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/page-not-found' },
];
